export const toFailure = action => `${action}_FAIL`
export const toSuccess = action => `${action}_SUCCESS`

export const optionsSignature = {
  onSuccess: {},
  onFailure: {},
  callBack: null,
}
